/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectCloudBackupPlan from 'modules/me/select-cloud-backup-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/cloud-backup');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Cloud Backup' subTitle={'Hello ' + businessName} selected='cloud-backup' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                The Cloud Backup service runs on your main computer to run incremental (changes only) 
                backups every 15 minutes of your entire main computer. This backup is stored locally 
                on your supplied NAS (network attached storage) so they can be accessed quickly should 
                the need arise. Additionally a second copy is securely uploaded via the Internet to 
                our cloud backup server. This negates the need for you to perform a nightly backup.
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Cloud Backup plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectCloudBackupPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewPlan);
